<template>
    <div>
        <CustomSelect
            v-if="isLivingInPoland"
            name="county"
            :value="county"
            idField="province"
            displayField="province"
            :options="polandCounties"
            :errorMessage="errors.county"
            label="county"
            @input="$emit('update:county', $event)"
            @valueChanged="$listeners.valueChanged"
            @blur="$listeners.blur"
        />
        <CustomSelect
            v-if="isLivingInPoland"
            name="city"
            :value="city"
            idField="name"
            displayField="name"
            :options="polandCountyCities"
            :errorMessage="errors.city"
            label="city"
            :disabled="!county"
            @input="$emit('update:city', $event)"
            @valueChanged="$listeners.valueChanged"
            @blur="$listeners.blur"
        />
        <CustomInput
            v-if="!isLivingInPoland"
            name="city"
            :value="city"
            label="city"
            :errorMessage="errors.city"
            @input="$emit('update:city', $event)"
            @valueChanged="$listeners.valueChanged"
            @blur="$listeners.blur"
        />
        <CustomInput
            name="postalCode"
            :value="postalCode"
            label="postal code"
            :errorMessage="errors.postalCode"
            @input="$emit('update:postalCode', $event)"
            @valueChanged="$listeners.valueChanged"
            @blur="$listeners.blur"
        />
        <CustomInput
            name="address"
            :value="address"
            label="address"
            :errorMessage="errors.address"
            @input="$emit('update:address', $event)"
            @valueChanged="$listeners.valueChanged"
            @blur="$listeners.blur"
        />
    </div>
</template>

<script>
    import { loadScript } from '@app/utils/scriptLoader';

    export default {
        props: {
            county: {
                type: String,
                required: false,
            },
            city: {
                type: String,
                required: true,
            },
            postalCode: {
                type: String,
                required: true,
            },
            isLivingInPoland: {
                type: Boolean,
                required: true,
            },
            address: {
                type: String,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                polandCounties: [],
            };
        },
        async created() {
            const polandCountiesUrl = `${window.location.origin}/static/js/counties-pl.js`;
            await loadScript(polandCountiesUrl, 'polandCounties');
            this.polandCounties = window.data.polandCounties;
        },
        computed: {
            polandCountyCities() {
                if (!this.county) {
                    return [];
                }

                return this.polandCounties.find((c) => c.province === this.county).cities;
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/authentication/components/register/Address.vue